import { accessTokenExpired as a, getRefreshToken as i, saveTokens as c } from "../../util/authenication/index.js";
import { singleOperation as f } from "../../util/operation/singleOperation.js";
import * as o from "ramda";
const T = "refreshToken", k = (s) => async () => {
  if (a()) {
    const e = await i();
    if (e) {
      const r = await fetch(s, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*"
        },
        body: JSON.stringify({
          query: `
                mutation RefreshAccessToken($refreshToken: String!) {
                  refreshAccessToken(refreshToken: $refreshToken)
                }
              `,
          variables: {
            refreshToken: e
          }
        })
      }), t = await r.json(), n = o.pathOr(
        "",
        ["data", "refreshAccessToken"],
        t
      );
      if (r.status === 401)
        return null;
      if (!o.isNil(n) && !o.isEmpty(n))
        return c(n, e), n;
    }
  }
  return null;
}, l = async (s) => await f(T, k(s));
export {
  l as renewAccessToken
};
//# sourceMappingURL=refreshToken.js.map
